export default "__VITE_ASSET__BICSZlCz__"